import React from "react";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "../data/site";

export default function Testimonials() {
    return (
        <section
            id="testimonianze"
            data-testid="testimonials-section"
            className="relative py-24 sm:py-32 overflow-hidden"
        >
            <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-gold/5 blur-3xl" />

            <div className="container mx-auto px-4 sm:px-6 lg:px-10 relative">
                <div className="max-w-3xl">
                    <div className="font-manrope text-sm uppercase tracking-[0.3em] text-gold mb-4">
                        Testimonianze
                    </div>
                    <h2
                        data-testid="testimonials-title"
                        className="font-oswald font-bold uppercase text-4xl sm:text-5xl lg:text-6xl text-white leading-[1]"
                    >
                        Le parole dei
                        <br />
                        <span className="text-shimmer">nostri atleti.</span>
                    </h2>
                </div>

                <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
                    {TESTIMONIALS.map((t, i) => (
                        <figure
                            key={t.name}
                            data-testid={`testimonial-${i}`}
                            className="relative bg-ink-surface p-7 border-l-4 border-gold rounded-r-xl hover:shadow-[0_10px_40px_rgba(212,175,55,0.1)] transition-shadow flex flex-col"
                        >
                            <Quote
                                size={36}
                                className="text-gold/15 absolute top-4 right-4"
                            />
                            <div className="flex gap-1 mb-3">
                                {[...Array(5)].map((_, idx) => (
                                    <Star
                                        key={idx}
                                        size={13}
                                        className="fill-gold text-gold"
                                    />
                                ))}
                            </div>
                            <blockquote className="font-manrope text-zinc-200 leading-relaxed text-sm flex-1">
                                "{t.text}"
                            </blockquote>
                            <figcaption className="mt-5 pt-4 border-t border-white/5">
                                <div className="font-oswald font-bold uppercase text-white text-sm tracking-wider">
                                    {t.name}
                                </div>
                                <div className="font-manrope text-[11px] tracking-widest text-gold uppercase mt-1">
                                    Cliente verificato
                                </div>
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
